import axios from 'axios';

import createUrlWithParams from 'helpers/createUrlWithParams';

const endpoint = 'api/v1/pocketsafe-administration/customer-exit/';

export type CustomerExitSummary = {
  id: number;
  organization: string;
  organization_number: string | null;
  status: string;
  created: string;
  contact_name: string | null;
  contact_email: string | null;
  action_templates: number;
  asset_action_instances: number;
  incidents: number;
  dsar_cases: number;
  dsar_asset_cases: number;
  assets: number;
  employees: number;
};

export type CustomerExitAuditLog = {
  id: number;
  created_at: string;
  action: string;
  organization_id: number | null;
  organization_name: string | null;
  performed_by: string | null;
  query: string;
  comment: string;
  export_id: number | null;
  metadata: Record<string, unknown>;
};

type Paginated<T> = {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
};

const downloadBlob = (data: any, filename: string) => {
  const blobUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/zip' }));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};

const customerExitApi = {
  searchCustomers: async (search: string): Promise<Paginated<CustomerExitSummary>> => {
    const { data } = await axios.get(createUrlWithParams(`${endpoint}customers/`, { search, limit: 25, offset: 0 }));
    return data;
  },
  getCustomer: async (id: number): Promise<CustomerExitSummary> => {
    const { data } = await axios.get(`${endpoint}customers/${id}/`);
    return data;
  },
  createExport: async (organizationId: number, comment: string) => {
    const { data } = await axios.post(`${endpoint}customers/${organizationId}/exports/`, { comment });
    return data;
  },
  downloadExport: async (exportId: number, filename: string) => {
    const response = await axios.get(`${endpoint}exports/${exportId}/download/`, { responseType: 'blob' });
    downloadBlob(response.data, filename);
  },
  getAuditLogs: async (organizationId?: number): Promise<Paginated<CustomerExitAuditLog>> => {
    const { data } = await axios.get(
      createUrlWithParams(`${endpoint}audit-logs/`, {
        limit: 25,
        offset: 0,
        ...(organizationId ? { organization_id: organizationId } : {}),
      }),
    );
    return data;
  },
};

export default customerExitApi;
